import { fillPdf } from "@/pdf/challengeProtocolDataFiller";
import { generatePdf } from "@/pdf/challengeProtocolPdfGenerator";
import { useImageDataUrlContext } from "@context/ImageDataUrlContext";
import { PdfData } from "@/models/pdfData";
import { IconButton, Tooltip } from "@mui/material";
import { FileOpen } from "@mui/icons-material";
import { FC, useState } from "react";
import { useGameDataContext } from "@context/GameDataContext";
import { FillerData } from "@/models/pdfModels";
import CompleteGameDataDialog from "@components/dialogs/CompleteGameDataDialog";

const DownloadPdfButton: FC<{
  game: PdfData | undefined;
  highlight?: boolean;
}> = ({ game, highlight = false }) => {
  const imageDataUrlContext = useImageDataUrlContext();
  const { updateLocation, updateGameNumber } = useGameDataContext();

  const [openCompleteDataDialog, setOpenCompleteDataDialog] = useState(false);

  const handleClose = () => setOpenCompleteDataDialog(false);

  const createPdf = (game: FillerData["data"]) =>
    window.open(
      fillPdf(generatePdf(imageDataUrlContext.dataUrls), game).output(
        `bloburl`,
      ),
    );

  return (
    <Tooltip
      title={
        game
          ? "Challenge Protokoll herunterladen"
          : "Spieldaten nicht verfügbar"
      }
    >
      <span>
        {game && openCompleteDataDialog && (
          <CompleteGameDataDialog
            open={openCompleteDataDialog}
            handleClose={handleClose}
            game={game}
            onCreateGame={(game) => {
              handleClose();
              updateLocation(game.gameData.location, game.samsId);
              updateGameNumber(game.gameData.gameNumber, game.samsId);
              createPdf(game);
            }}
          />
        )}
        <IconButton
          color={highlight ? "success" : "default"}
          disabled={!game}
          onClick={() => {
            if (game) {
              if (!(game.gameData.gameNumber && game.gameData.location)) {
                setOpenCompleteDataDialog(true);
              } else {
                createPdf(game as FillerData["data"]);
              }
            }
          }}
        >
          <FileOpen />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default DownloadPdfButton;
